  import {
  createContext,
  FC,
  ReactNode, useContext, useEffect, useReducer
} from "react";
import { setErrorReportingUser } from "src/utils/error-reporting";
import { useUserDataStore } from "src/hooks/snug/use-userData";
import {
  Household,
  UserDataObj,
} from "src/types/snugtotal";

type PeopleRolesStoreAction =
  {
    type: "SET_PRO_HOUSEHOLD_CONTEXT";
    payload: Household | null;
  };

// Define reducer function for usePeopleRolesStore
const peopleRolesStoreReducer = (
  state: UserDataContextStoreState,
  action: PeopleRolesStoreAction
): UserDataContextStoreState => {
  switch (action.type) {
    case "SET_PRO_HOUSEHOLD_CONTEXT":
      return { ...state, proHouseHoldContext: action.payload };
    default:
      return state;
  }
};

export interface UserDataContexType {
  ownerUserData: UserDataObj | null;
  userData: UserDataObj | null;
  userDataInitialLoading: boolean;
  userDataSaving: boolean;
  ownerUserDataInitialLoading: boolean;
  isProfessional: boolean;
  handleAddOrEditOwnerUserData: (userData: UserDataObj) => void;
  updateProHouseholdContext: (household: Household) => void;
}

interface UserDataContextStoreState {
  proHouseHoldContext: Household | null;
}

export const UserDataContext = createContext<UserDataContexType>(
  {} as UserDataContexType
);

interface UserDataProviderProps {
  children: ReactNode;
}

// Possible refactore would be to handle api selection here
export const UserDataProvider: FC<UserDataProviderProps> = (props) => {
  const { children } = props;
  const {
    userData,
    userDataInitialLoading,
    userDataSaving,
    handleAddOrEditOwnerUserData,
  } = useUserDataStore(true);

  useEffect(() => {
    setErrorReportingUser(userData?.ud_id);
  }, [userData?.ud_id]);

  const [state, dispatch] = useReducer(peopleRolesStoreReducer, {
    proHouseHoldContext: null,
  });

  // this is a function to update the pro household context from a household object
  const updateProHouseholdContext = (household: Household) => {
    dispatch({ type: "SET_PRO_HOUSEHOLD_CONTEXT", payload: household });
  }

  return (
    <UserDataContext.Provider
      value={{
        ownerUserData: userData,
        userData: state.proHouseHoldContext?.head_of_household || userData,
        userDataInitialLoading,
        userDataSaving,
        ownerUserDataInitialLoading: userDataInitialLoading,
        isProfessional: userData?.professional_group_role_user_data ? true : false,
        handleAddOrEditOwnerUserData,
        updateProHouseholdContext
      }}
    >
      {children}
    </UserDataContext.Provider>
  );
};

export default function useUserDataProvider() {
  return useContext(UserDataContext);
}
